import {BaseField} from './base-field';
import {textFieldMixin} from './text-field-mixin';

/**
 * @classdesc Text Field
 *
 * @class TextField
 * @extends {BaseField}
 * @mixes textFieldMixin
 * @version 1.0.0
 * @path
 */
class TextField extends textFieldMixin(BaseField) {
	getInput() {
		return this.querySelector('input[type="text"]');
	}
}

export {TextField};
